module.exports = __webpack_public_path__ + "media/en_us_s5_Wesley.008062dc.oga";